import { BreadcrumbDefinition, MainLayout } from '@components/Layout';
import { HeaderText } from '@components/Layout/HeaderText';
import {
  CrossChannelExportModal,
  useCrossChannelAnalysisEnabled,
} from '@features/cross-channel-analysis';
import { faFileExport } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Stack, Typography } from '@mui/material';
import { useReducer, useState } from 'react';
import { CampaignDataGrid } from '../components/CampaignDataGrid';
import { Filters } from '../components/Filters';
import { reducer } from '../stores/reducer';
import { initialState } from '../domain/filter';
import { FilterContext } from '../stores/filter-context';

type CampaignListProps = {
  breadcrumbs: BreadcrumbDefinition[];
};

export const CampaignList = (props: CampaignListProps) => {
  const [filterState, dispatch] = useReducer(reducer, initialState);
  const crossChannelAnalysisEnabled = useCrossChannelAnalysisEnabled();
  const [modalIsOpen, setModalIsOpen] = useState(false);

  return (
    <MainLayout breadcrumbs={props.breadcrumbs}>
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <HeaderText>Campaign List</HeaderText>
        {crossChannelAnalysisEnabled ? (
          <Button
            variant="outlined"
            startIcon={<FontAwesomeIcon icon={faFileExport} />}
            onClick={() => setModalIsOpen(true)}
          >
            Cross-Channel Analysis Export
          </Button>
        ) : null}
      </Stack>
      <Typography>
        All your Media Measurement campaigns in one place!
      </Typography>
      <FilterContext.Provider value={{ filterState, dispatch }}>
        <Filters />
        <CampaignDataGrid />
      </FilterContext.Provider>
      {crossChannelAnalysisEnabled ? (
        <CrossChannelExportModal
          open={modalIsOpen}
          onClose={() => setModalIsOpen(false)}
        />
      ) : null}
    </MainLayout>
  );
};
